import React, { useState } from "react"
import { CompanyData } from "../api/auth/actions"
import DropdownControl from "./DropdownControl"
import { Button } from "react-bootstrap"
import Label from "./Label"

type CompanySelectProps = {
    companies: CompanyData[]
    onSelect: (company: CompanyData) => void
    err: string
    initial?: number    // index preselected on open. defaults to the first company
}

const CompanySelect: React.FC<CompanySelectProps> = ({ companies, onSelect, err, initial }) => {
    const [selectedCompany, setSelectedCompany] = useState(initial ?? 0)
    return <div className="center invite-container" style={{ width: 450 }}>
        {err !== "" && <Label color="red" size="medium" margin="10px 0px 0px 0px">{err}</Label>}
        <DropdownControl text="Select company"
            selected={selectedCompany}
            items={companies.map(company => company.name)}
            onSelected={(key, index) => {
                setSelectedCompany(index)
            }} />
        <Button style={{ float: 'right', marginTop: '10px' }}
            onClick={() => onSelect(companies[selectedCompany])}>Continue</Button>
    </div>
}

export default CompanySelect
